var exports = {
  "Tp": "x93eb46d8--8f4c01--background",
  "KI": "x93eb46d8--8f4c01--icon_container",
  "Kk": "x93eb46d8--8f4c01--icon",
  "rV": "x93eb46d8--8f4c01--click_area",
  "q9": "x93eb46d8--8f4c01--click_area--left",
};

module.exports = exports;
